import { Injectable } from '@angular/core';

import { RacingConfig } from '@frontend/sports/common/client-config-data-access';
import { Observable, concat, count } from 'rxjs';

import { hasBestOddsGuaranteeFlag } from '../../../betslip/modules/reward-tokens/validators';
import { BestOddsFixtureLikeInput } from '../models/models';

@Injectable({ providedIn: 'root' })
export abstract class BestOddsGuaranteedService {
    constructor(protected racingConfig: RacingConfig) {}

    abstract isFixtureEligible(fixture: BestOddsFixtureLikeInput): Observable<boolean>;

    isFixtureBogEligible(fixture: BestOddsFixtureLikeInput): boolean {
        return !!this.racingConfig.isBOGEnabled && hasBestOddsGuaranteeFlag(fixture);
    }

    getEligibleFixturesCount(fixtures: BestOddsFixtureLikeInput[]): Observable<number> {
        return concat(...fixtures.map((f) => this.isFixtureEligible(f))).pipe(count((eligible) => eligible));
    }
}
